// extracted by mini-css-extract-plugin
module.exports = {"title":"alertDialog_title__3S6c3","text":"alertDialog_text__2QNq2","paper":"alertDialog_paper__21eMl","root":"alertDialog_root__3sQTt","btn":"alertDialog_btn__3i2g2"};